<script setup lang="ts">
import type { BagAllowance } from '@optionway/models';

const properties = defineProps<{ bagAllowances: BagAllowance[]; loading?: boolean }>();
</script>

<template>
  <UiSkeleton
    v-if="properties.loading"
    class="mr-2 h-7 w-8"
  />
  <div
    v-else
    class="flex space-x-3"
  >
    <div
      v-if="properties.bagAllowances.length === 0"
      class="relative mr-2 mt-2 flex items-center justify-start"
    >
      <UiCustomBagAllowancesLuggage
        type="CHECKED"
        bookable-by="LEG"
        source="FARE"
        :pieces="0"
      />
    </div>
    <div
      v-for="(bag, i) in properties.bagAllowances"
      :key="`${bag.type}-${i}`"
      class="relative mr-2 mt-2 flex items-center justify-start"
    >
      <UiCustomBagAllowancesLuggage v-bind="bag" />
    </div>
  </div>
</template>
